// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"739359d7","274":"c7a0bf98","435":"ae35cd5a","453":"db1ae85e","533":"ddd3e5ab","599":"494b9835","613":"684b0010","633":"2a4ff9c3","764":"9c973ed3","837":"855ea564"}[chunkId] + ".chunk.js";
};